<template>
  <div class="callback">
    <div class="spinner" />
    <p class="muted">Completing sign-in…</p>
  </div>
</template>

<script setup>
import { onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { getSession } from '../services/auth'

const router = useRouter()

onMounted(async () => {
  try {
    // Amplify v6 completes the OAuth code exchange on load;
    // fetchAuthSession / getCurrentUser confirm the session.
    const session = await getSession()
    if (session) {
      router.replace('/')
    } else {
      router.replace('/login')
    }
  } catch {
    router.replace('/login')
  }
})
</script>

<style scoped>
.callback {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
}
</style>
